document.addEventListener('DOMContentLoaded', function () {

  /* ============ Mega menu ============ */
  (function () {
    var triggers = document.querySelectorAll('.nav-trigger');
    var panels = document.querySelectorAll('.mega');
    if (!triggers.length) return;
    var openPanel = null;

    function closeAll(returnFocusTo) {
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      panels.forEach(function (p) { p.classList.remove('open'); });
      openPanel = null;
      if (returnFocusTo) returnFocusTo.focus();
    }
    function openMenu(trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      if (openPanel === panel) { closeAll(); return; }
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', t === trigger ? 'true' : 'false'); });
      panels.forEach(function (p) { p.classList.toggle('open', p === panel); });
      openPanel = panel;
    }
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () { openMenu(trigger); });
      trigger.addEventListener('mouseenter', function () { openMenu(trigger); });
      var li = trigger.closest('li');
      li.addEventListener('mouseleave', function () {
        setTimeout(function () {
          if (!document.querySelector('.mega:hover')) closeAll();
        }, 150);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openPanel) {
        closeAll(document.querySelector('.nav-trigger[aria-expanded="true"]'));
      }
    });
    document.addEventListener('click', function (e) {
      if (openPanel && !e.target.closest('.mega') && !e.target.closest('.nav-trigger')) closeAll();
    });
  })();

  /* ============ Mobile nav drawer ============ */
  (function () {
    var toggle = document.querySelector('.mobile-toggle');
    var nav = document.getElementById('mobileNav');
    if (!toggle || !nav) return;
    var closeBtn = nav.querySelector('.mobile-nav-close');

    function open() { nav.classList.add('open'); toggle.setAttribute('aria-expanded', 'true'); if (closeBtn) closeBtn.focus(); }
    function close() { nav.classList.remove('open'); toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
    toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    nav.addEventListener('click', function (e) { if (e.target === nav) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.classList.contains('open')) close(); });
  })();

  /* ============ Live chat widget ============ */
  (function () {
    var toggle = document.getElementById('chatToggle');
    var panel = document.getElementById('chatPanel');
    if (!toggle || !panel) return;
    var closeBtn = document.getElementById('chatClose');
    var form = document.getElementById('chatForm');
    var input = document.getElementById('chatInput');
    var messages = document.getElementById('chatMessages');

    function openChat() { panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); if (input) input.focus(); }
    function closeChat() { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
    toggle.addEventListener('click', function () { panel.hidden ? openChat() : closeChat(); });
    if (closeBtn) closeBtn.addEventListener('click', closeChat);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) closeChat(); });

    function addMessage(text, who) {
      var div = document.createElement('div');
      div.className = 'chat-msg ' + who;
      div.textContent = text;
      messages.appendChild(div);
      messages.scrollTop = messages.scrollHeight;
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var val = input.value.trim();
        if (!val) return;
        addMessage(val, 'user');
        input.value = '';
        setTimeout(function () {
          addMessage('Thanks — a concierge will jump in shortly. Feel free to browse the Custom Studio in the meantime.', 'agent');
        }, 700);
      });
    }
  })();

  /* ============ Product card metal toggle (collection / featured collection) ============ */
  document.querySelectorAll('.product-card[data-metal-option]').forEach(function (card) {
    var pills = card.querySelectorAll('.metal-pill');
    var priceEl = card.querySelector('.price-amount');
    var maps = card.querySelectorAll('.variant-id-map');
    var variantInput = card.querySelector('.product-form-variant-id');

    function money(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
        pill.setAttribute('aria-pressed', 'true');
        var value = pill.dataset.metalValue;
        maps.forEach(function (m) {
          if (m.dataset.metalValue === value) {
            if (priceEl) priceEl.textContent = money(parseInt(m.dataset.variantPrice, 10));
            if (variantInput) variantInput.value = m.dataset.variantId;
          }
        });
      });
    });
  });

  /* ============ PDP option pills (main product form) ============ */
  (function () {
    var form = document.getElementById('ProductForm');
    if (!form) return;
    var select = document.getElementById('ProductVariantSelect');
    var priceEl = document.getElementById('ProductPrice');
    var addBtn = document.getElementById('AddToCartButton');
    var pills = form.querySelectorAll('.option-pill');
    var selections = {};

    pills.forEach(function (pill) {
      if (pill.getAttribute('aria-pressed') === 'true') selections[pill.dataset.optionIndex] = pill.dataset.value;
    });

    function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

    function syncVariant() {
      var options = select.querySelectorAll('option');
      var match = null;
      options.forEach(function (opt) {
        var titleParts = opt.textContent.trim().split(' / ');
        var allMatch = Object.keys(selections).every(function (idx) {
          return titleParts[idx] === selections[idx];
        });
        if (allMatch) match = opt;
      });
      if (match) {
        select.value = match.value;
        if (priceEl) priceEl.textContent = money(parseInt(match.dataset.price, 10));
        if (addBtn) addBtn.disabled = false;
      } else if (addBtn) {
        addBtn.disabled = true;
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = pill.dataset.optionIndex;
        form.querySelectorAll('.option-pill[data-option-index="' + idx + '"]').forEach(function (p) {
          p.setAttribute('aria-pressed', 'false');
        });
        pill.setAttribute('aria-pressed', 'true');
        selections[idx] = pill.dataset.value;
        syncVariant();
      });
    });

    var thumbs = document.querySelectorAll('.thumb-swap');
    var mainImg = document.getElementById('MainProductImage');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (mainImg) mainImg.src = t.dataset.full;
      });
    });
  })();

  /* ============ Custom Commission funnel wizard ============ */
  (function () {
    var wizard = document.getElementById('wizardSteps');
    if (!wizard) return;

    var panels = wizard.querySelectorAll('.step-panel');
    var stepItems = document.querySelectorAll('#stepsList li');
    var current = 1;

    function showStep(n) {
      panels.forEach(function (p) { p.classList.toggle('active', parseInt(p.dataset.panel, 10) === n); });
      stepItems.forEach(function (li) {
        var s = parseInt(li.dataset.step, 10);
        li.classList.toggle('active', s === n);
        li.classList.toggle('done', s < n);
      });
      current = n;
      wizard.querySelector('.step-panel.active').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function fieldValue(name) {
      var el = wizard.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : null;
    }

    function refreshSummary() {
      var map = { sumPiece: 'pieceType', sumMetal: 'metal', sumStone: 'stone', sumBudget: 'budget' };
      Object.keys(map).forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.textContent = fieldValue(map[id]) || '\u2014';
      });
    }

    wizard.addEventListener('click', function (e) {
      if (e.target.matches('[data-next]')) {
        if (current === 1 && !fieldValue('pieceType')) {
          alert('Please choose a piece type to continue.');
          return;
        }
        if (current < 4) showStep(current + 1);
      }
      if (e.target.matches('[data-prev]')) {
        if (current > 1) showStep(current - 1);
      }
    });
    wizard.addEventListener('change', refreshSummary);
    refreshSummary();

    /* file upload (visual only — Shopify's contact form can't attach files without an app) */
    var dropzone = document.getElementById('dropzone');
    var fileInput = document.getElementById('fileInput');
    var fileList = document.getElementById('fileList');
    var files = [];

    function renderFiles() {
      if (!fileList) return;
      fileList.innerHTML = '';
      files.forEach(function (f, i) {
        var row = document.createElement('div');
        row.className = 'file-row';
        var name = document.createElement('span');
        name.textContent = f.name + ' (' + Math.round(f.size / 1024) + ' KB)';
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.textContent = 'Remove';
        rm.addEventListener('click', function () { files.splice(i, 1); renderFiles(); });
        row.appendChild(name); row.appendChild(rm);
        fileList.appendChild(row);
      });
    }
    if (dropzone && fileInput) {
      dropzone.addEventListener('click', function () { fileInput.click(); });
      dropzone.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); } });
      fileInput.addEventListener('change', function (e) { files = files.concat(Array.from(e.target.files)); renderFiles(); });
      ['dragover', 'dragenter'].forEach(function (evt) { dropzone.addEventListener(evt, function (e) { e.preventDefault(); dropzone.classList.add('drag'); }); });
      ['dragleave', 'drop'].forEach(function (evt) { dropzone.addEventListener(evt, function (e) { e.preventDefault(); dropzone.classList.remove('drag'); }); });
      dropzone.addEventListener('drop', function (e) {
        if (e.dataTransfer.files.length) { files = files.concat(Array.from(e.dataTransfer.files)); renderFiles(); }
      });
    }

    function summaryText() {
      var lines = [];
      lines.push('Piece type: ' + (fieldValue('pieceType') || '-'));
      lines.push('Metal: ' + (fieldValue('metal') || '-'));
      lines.push('Stone: ' + (fieldValue('stone') || '-'));
      lines.push('Setting: ' + (fieldValue('setting') || '-'));
      lines.push('Budget: ' + (fieldValue('budget') || '-'));
      var dimSize = document.getElementById('dimSize');
      var dimFit = document.getElementById('dimFit');
      if (dimSize && dimSize.value) lines.push('Dimensions: ' + dimSize.value);
      if (dimFit && dimFit.value) lines.push('Fit: ' + dimFit.value);
      var desc = document.getElementById('designDesc');
      if (desc && desc.value) lines.push('Design notes: ' + desc.value);
      if (files.length) lines.push('Reference files (names only — concierge will request the actual files): ' + files.map(function (f) { return f.name; }).join(', '));
      var deadline = document.getElementById('cDeadline');
      if (deadline && deadline.value) lines.push('Target date: ' + deadline.value);
      var contactMethod = document.getElementById('cContact');
      if (contactMethod) lines.push('Preferred contact method: ' + contactMethod.value);
      return lines.join('\n');
    }

    /* Populate the free-quote (native Shopify contact) form right before submit */
    var quoteForm = document.getElementById('QuoteForm');
    if (quoteForm) {
      quoteForm.addEventListener('submit', function () {
        document.getElementById('quoteName').value = (document.getElementById('cName') || {}).value || '';
        document.getElementById('quoteEmail').value = (document.getElementById('cEmail') || {}).value || '';
        document.getElementById('quotePhone').value = (document.getElementById('cPhone') || {}).value || '';
        document.getElementById('quoteBody').value = summaryText();
      });
    }

    /* Populate the CAD deposit add-to-cart form (line item properties) right before submit */
    var depositForm = document.getElementById('DepositForm');
    if (depositForm) {
      depositForm.addEventListener('submit', function () {
        var setVal = function (id, val) { var el = document.getElementById(id); if (el) el.value = val || ''; };
        setVal('propPiece', fieldValue('pieceType'));
        setVal('propMetal', fieldValue('metal'));
        setVal('propStone', fieldValue('stone'));
        setVal('propSetting', fieldValue('setting'));
        setVal('propBudget', fieldValue('budget'));
        setVal('propNotes', (document.getElementById('designDesc') || {}).value);
        setVal('propFiles', files.map(function (f) { return f.name; }).join(', '));
        setVal('propContact', (document.getElementById('cContact') || {}).value);
        setVal('propDeadline', (document.getElementById('cDeadline') || {}).value);
      });
    }
  })();

});
